module.exports = __webpack_public_path__ + "static/media/alfabank.1269045f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alfabank.png
// module id = 487
// module chunks = 0